import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function(params) {
      return qs.stringify(params, { encode: false });
    }
  };

  return axios.get(`${url}/subcorridas`, options).then(response => {
    return {
      list: response.data.data, 
      meta: response.data.meta
    };
  });
}

function getMotivoIngreso(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };
  
  return axios
    .get(`${url}/movimientos_caja/motivosIngreso`, options)
    .then(response => {
        return jsona.deserialize(response.data);
    });
}

function getMotivoEgreso(id) {
const options = {
    headers: {
    Accept: "application/vnd.api+json",
    "Content-Type": "application/vnd.api+json"
    }
};

return axios
    .get(`${url}/movimientos_caja/motivosEgreso`, options)
    .then(response => {
        return jsona.deserialize(response.data);
    });
}
function add(corrida) {
  const payload = jsona.serialize({
    stuff: corrida,
    includeNames: null
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .post(`${url}/subcorridas`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}


export default {
  list,
  getMotivoEgreso,
  getMotivoIngreso,
  add
};
